import React from "react";
import { Bot, FolderKanban } from "lucide-react";
import { FaAddressCard, FaBookReader } from "react-icons/fa";

function FourthPage() {
  return (
    <div className="py-5" style={{ background: "linear-gradient(to right, #ebf8ff, #f3e8ff)" }}>
      <div className="container">
        <div className="text-center text-white mb-5">
          <h2
            className="fw-bold mb-3 fs-1 fw-bolder"
            style={{
              background: "linear-gradient(to right, #2563eb, #7c3aed)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Our Comprehensive AI-Agentic Model based Learning 
          </h2>
          <p className="text-muted mb-2">
          Leverage our cutting-edge models to enhance your skills and prepare for real-world challenges
          </p>
          <p className="fw-bold text-dark">
          Developed and fine-tuned by IITians, Successful Entrepreneurs & Industry Veterans
          </p>
        </div>

        <div className="row justify-content-center">
          {/* AI Interviewer */}
          <div className="col-md-3 mb-4">
            <div
              className="card text-white h-100 text-center border-0"
              style={{ background: "linear-gradient(to bottom, #3b82f6, #2563eb)", borderRadius: "1rem" }}
            >
              <div className="card-body">
                <div className="mb-3 d-flex justify-content-center">
                  <div className="bg-white p-3 rounded-circle">
                    <Bot size={50} color="#2563eb" />
                  </div>
                </div>
                <h5 className="card-title text-white fw-bold">AI - Interviewer</h5>
                <p className="card-text text-light mb-4">Practice your Interview with AI-Mock Practitioner (upcoming)</p>
                <a href="/interviewer_page" className="btn btn-light text-primary fw-bold">Click Here</a> <br/>
                <span className="text-light fw-medium ms-2">coming soon...</span>

              </div>
            </div>
          </div>

          {/* Projects */}
          <div className="col-md-3 mb-4">
            <div
              className="card text-white h-100 text-center border-0"
              style={{ background: "linear-gradient(to bottom,rgb(123, 152, 10), #15803d)", borderRadius: "1rem" }}
            >
              <div className="card-body">
                <div className="mb-3 d-flex justify-content-center">
                  <div className="bg-white p-3 rounded-circle">
                    <FolderKanban size={50} color="#16a34a" />
                  </div>
                </div>
                <h5 className="card-title text-white fw-bold">250+ Projects </h5>
                <p className="card-text text-white mb-4">Top Real Time Projects based on Fortune/MNC Companies</p>
                <a href="/our_projects" className="btn btn-light text-success fw-bold">
                  Click Here
                </a>
              </div>
            </div>
          </div>

          {/* Internships */}
          <div className="col-md-3 mb-4">
            <div
              className="card text-white h-100 text-center border-0"
              style={{ background: "linear-gradient(to bottom,rgb(0, 128, 160),#192991)", borderRadius: "1rem" }}
            >
              <div className="card-body">
                <div className="mb-3 d-flex justify-content-center">
                  <div className="bg-white p-3 rounded-circle">
                    <FaAddressCard size={50} color="#192991" />
                  </div>
                </div>
                <h5 className="card-title text-white fw-bold">100% Free </h5>
                <p className="card-text mb-4 text-light">Prepare Your Own Resume with ATS Score for desired Job Roles Based on Description</p>
                <button ><a className="btn btn-light text-dark fw-bold" href="/ai_resumepage">Create Your Resume </a>
                </button>
              </div>
            </div>
          </div>
 {/* resume builder page*/}
 <div className="col-md-3 mb-4">
            <div
              className="card text-white h-100 text-center border-0"
              style={{ background: "linear-gradient(to bottom,rgb(65, 196, 109),#192991)", borderRadius: "1rem" }}
            >
              <div className="card-body">
                <div className="mb-3 d-flex justify-content-center">
                  <div className="bg-white p-3 rounded-circle">
                    <FaBookReader size={50} color="#192991" />
                  </div>
                </div>
                <h5 className="card-title text-white fw-bold">100% Free</h5>
                <p className="card-text mb-4 text-light"> Resume Builder using AI and ATS Score Analyser </p>
                <a className="btn btn-light text-dark fw-bold" href="/resume_builder">AI Resume Builder</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default FourthPage;
